import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { NeuButton, NeuCard, NeuInput } from "../../components/neu/Neu";
import { deleteUser } from "../../api/directory";
import { useAuth } from "../../context/AuthContext";
import { isCompanyAdmin } from "../../utils/role";

// Delete lives inside the employee card, guarded by typing the employee name.
export const EmployeeDangerZone = ({ employee }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  const name = employee?.name || "";
  // زر الحذف حصراً لمدير الشركة، ولا يظهر أبداً على مدير شركة آخر أو على النفس.
  if (!isCompanyAdmin(user)) return null;
  if (employee?.role === "company_admin") return null;
  if (employee?.id === user._id) return null;

  const remove = async () => {
    setBusy(true);
    try {
      await deleteUser(employee.id);
      toast.success(t("employees.deleted"));
      navigate("/employees");
    } catch {
      toast.error(t("errors.generic"));
      setBusy(false);
    }
  };

  return (
    <NeuCard className="lg:col-span-3 border border-destructive/30" data-testid="detail-danger-zone">
      <p className="label-xs text-destructive">{t("detail.dangerZone")}</p>
      <p className="mt-2 text-sm text-muted-foreground">{t("detail.deleteHint")}</p>

      {!open ? (
        <NeuButton
          variant="danger"
          className="mt-4 flex items-center gap-2 px-4 py-2"
          data-testid="detail-delete"
          onClick={() => setOpen(true)}
        >
          <Trash2 className="h-4 w-4" /> {t("detail.delete")}
        </NeuButton>
      ) : (
        <div className="mt-4 grid gap-3 sm:max-w-md" data-testid="detail-delete-confirm">
          <p className="text-xs font-bold">{t("detail.typeNameToConfirm", { name })}</p>
          <NeuInput
            data-testid="detail-delete-name"
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            placeholder={name}
          />
          <div className="flex gap-2">
            <NeuButton
              variant="danger"
              className="px-4 py-2"
              data-testid="detail-delete-confirm-btn"
              disabled={busy || typed.trim() !== name.trim()}
              onClick={remove}
            >
              {busy ? t("app.saving") : t("detail.deleteConfirm")}
            </NeuButton>
            <NeuButton className="px-4 py-2" data-testid="detail-delete-cancel" onClick={() => setOpen(false)}>
              {t("app.cancel")}
            </NeuButton>
          </div>
        </div>
      )}
    </NeuCard>
  );
};
